import { FunctionComponent, useEffect } from 'react';
import makeAsyncScriptLoader from 'react-async-script';
import { Frame } from '@shopify/polaris';
import { useIsImpersonator } from '@hooks/auth';

const FrameAsyncScriptHoc = makeAsyncScriptLoader(
  `//js.hs-scripts.com/${HUBSPOT_HUB_ID}.js`,
)(Frame);

const FrameHubspotHoc: FunctionComponent = (props) => {
  const { children } = props;
  const isAdmin = useIsImpersonator();

  useEffect(() => {
    if (window) {
      window.hsConversationsSettings = {
        loadImmediately: false,
      };
    }
  }, []);

  if (!HUBSPOT_HUB_ID || isAdmin) {
    return <Frame>{children}</Frame>;
  }

  return <FrameAsyncScriptHoc>{children}</FrameAsyncScriptHoc>;
};

export default FrameHubspotHoc;
